export type PillarRating = 1 | 2 | 3 | 4 | 5;

export type AlignmentArea =
  | 'mindset'
  | 'outreach'
  | 'delivery'
  | 'ops';

export interface AlignmentAudit {
  id: string;
  user_id: string;
  created_at: string;
  mindset_rating?: PillarRating;
  outreach_rating?: PillarRating;
  delivery_rating?: PillarRating;
  ops_rating?: PillarRating;
  selected_area: string;
  celebrate?: string;
  learn?: string;
  goal?: string;
  fear?: string;
  values_vision?: string;
  action?: string;
  completed_at?: string;
  task_id?: string;
}

export interface PillarConfig {
  id: AlignmentArea;
  name: string;
  ratingKey: 'mindset_rating' | 'outreach_rating' | 'delivery_rating' | 'ops_rating';
  question: string;
  description: string;
}

export interface AuditQuestion {
  id: string;
  title: string;
  prompt: string;
  placeholder: string;
  field: 'celebrate' | 'learn' | 'goal' | 'fear' | 'values_vision' | 'action';
}

export const PILLARS: PillarConfig[] = [
  {
    id: 'mindset',
    name: 'Mindset & Vision',
    ratingKey: 'mindset_rating',
    question: 'How certain are you that your mindset and vision support your business growth?',
    description: 'Your internal clarity, beliefs, and strategic direction'
  },
  {
    id: 'outreach',
    name: 'Outreach & Conversion',
    ratingKey: 'outreach_rating',
    question: 'How certain are you that your outreach and conversion systems are optimized?',
    description: 'Your lead generation, sales process, and client acquisition'
  },
  {
    id: 'delivery',
    name: 'Delivery & Onboarding',
    ratingKey: 'delivery_rating',
    question: 'How certain are you that your delivery and onboarding process delights clients?',
    description: 'Your service delivery, client experience, and value realization'
  },
  {
    id: 'ops',
    name: 'Internal Ops & Follow-Up',
    ratingKey: 'ops_rating',
    question: 'How certain are you that your operations and follow-up systems work smoothly?',
    description: 'Your backend systems, team coordination, and client retention'
  }
];

export const AUDIT_QUESTIONS: AuditQuestion[] = [
  {
    id: 'celebrate',
    title: 'Celebrate',
    prompt: 'What is a recent win in this area?',
    placeholder: 'Describe a recent success or positive moment...',
    field: 'celebrate'
  },
  {
    id: 'learn',
    title: 'Learn',
    prompt: 'What did you learn from your win?',
    placeholder: 'What insights did you gain from this experience?',
    field: 'learn'
  },
  {
    id: 'goal',
    title: 'Goal',
    prompt: 'What is your pressing goal for this area?',
    placeholder: 'What do you need to achieve or improve right now?',
    field: 'goal'
  },
  {
    id: 'fear',
    title: 'Fear',
    prompt: 'What are the fears, doubts, or concerns that come up in this area?',
    placeholder: 'What fear, doubt, or obstacle keeps showing up?',
    field: 'fear'
  },
  {
    id: 'values_vision',
    title: 'Values Integration',
    prompt: 'What do your values say to do regarding your goal? Create a list.',
    placeholder: 'List how your values guide your actions...',
    field: 'values_vision'
  },
  {
    id: 'action',
    title: 'Action',
    prompt: 'What is one action you can take today?',
    placeholder: 'One concrete step that addresses the system...',
    field: 'action'
  }
];
